export default __webpack_public_path__ + "static/media/audio.146fa802.svg";